export class DescendantVisitor {
  constructor(startNode) {
    this.startNode = startNode
    this.descendants = []
  }

  enterNode({ currentNode }) {
    if (currentNode.field_id !== this.startNode.field_id) {
      this.descendants.push(currentNode)
    }
  }

  allowTraversal() {
    // assume that no cycles exist
    return true
  }

  getDescendantPath() {
    return this.descendants
  }
}
